//
// Sitewide JavaScript code, admin-site
//

$(document).ready(function() {

    // if an ACTIVE_NAV global is defined, find that item in the nav menu and tag is as .active so it gets alternate coloring
    if (typeof ACTIVE_NAV !== 'undefined') {
        $('nav.navbar a[data-active="'+ACTIVE_NAV+'"]').addClass('active-nav');
    }

});